<template>
  <pt-adult-sell-order-handle class="pt-adult-sell-order-handle__withData"></pt-adult-sell-order-handle>
</template>

<script>
import PtAdultSellOrderHandle from './index'
export default {
  name: 'pt-adult-sell-order-handle__withData',
  components: {
    'pt-adult-sell-order-handle': PtAdultSellOrderHandle
  }
}
</script>
